<template>
    <v-container fluid>
        <v-row>
            <v-col
                cols="12"
                md="6"
            >
                <v-card>
                    <v-form
                        ref="accountForm"
                        v-model="isValid"
                    >
                        <v-card-text>
                            <v-container
                                class="pb-0"
                                fluid
                            >
                                <v-row class="pb-0">
                                    <v-col
                                        cols="12"
                                        justify="start"
                                    >
                                        <v-btn
                                            @click="loadPatientFindForm"
                                            class="text-none"
                                            color="light-blue darken-1"
                                            dark
                                            v-if="!account.patient"
                                        >
                                            <v-icon
                                                dark
                                                left
                                            >mdi-account</v-icon>Specify Patient
                                        </v-btn>
                                        <v-btn
                                            @click="account.patient = null; account.patientId = 0"
                                            class="text-none"
                                            color="light-blue darken-1"
                                            text
                                            v-else
                                        >
                                            <v-icon
                                                dark
                                                left
                                            >mdi-close</v-icon>Clear Patient
                                        </v-btn>
                                        <v-card v-if="account.patient">
                                            <v-card-text>
                                                Incident #{{ account.patient.incidentId }}
                                                <br />
                                                {{ account.patient.identity.name }}
                                                {{ account.patient.identity.surname }}
                                                <br />
                                                <span v-if="identityTypes">
                                                    {{
                                                    identityTypes.find(
                                                    (x) =>
                                                    x.key == account.patient.identity.identityTypeId
                                                    )
                                                    ? identityTypes.find(
                                                    (x) =>
                                                    x.key ==
                                                    account.patient.identity.identityTypeId
                                                    ).value
                                                    : ""
                                                    }}
                                                </span>
                                                :
                                                {{ account.patient.identity.identificationNumber }}
                                            </v-card-text>
                                        </v-card>
                                        <br />
                                        <div
                                            style="color: red"
                                            v-show="!account.patient"
                                        >Patient identity is required</div>
                                    </v-col>

                                    <v-col cols="12">
                                        <v-select
                                            :disabled="isLoading || account.id > 0"
                                            :items="activeProviders"
                                            :rules="[requiredRule]"
                                            @change="populateProviderDisciplines"
                                            clearable
                                            item-text="value"
                                            item-value="key"
                                            label="Provider"
                                            v-model="account.providerId"
                                        ></v-select>
                                    </v-col>

                                    <v-col cols="12">
                                        <v-select
                                            :disabled="isLoading || account.id > 0"
                                            :items="providerDisciplines"
                                            :rules="[(v) => !!v || v === 0 || 'required']"
                                            clearable
                                            item-text="value"
                                            item-value="key"
                                            label="Discipline"
                                            v-model="account.discipline"
                                        ></v-select>
                                    </v-col>

                                    <v-col cols="12">
                                        <v-select
                                            :disabled="isLoading || isServiceProviderUser || !(account.id>0)"
                                            :items="accountStatuses"
                                            :rules="[requiredRule]"
                                            clearable
                                            item-text="value"
                                            item-value="key"
                                            label="Status"
                                            v-model="account.accountStatus"
                                        ></v-select>
                                        <v-expand-transition>
                                            <v-textarea
                                                :rules="[ requiredQueryRejectReasonRule, lengthRule(512)]"
                                                counter
                                                label="Status Change Reason"
                                                v-model="account.queryText"
                                                v-show="showQueryRejectReasonInput"
                                            ></v-textarea>
                                        </v-expand-transition>
                                        <v-expand-transition>
                                            <v-card v-show="accountIn.accountStatus != account.accountStatus && account.accountStatus == allAccountStatuses.Queried && account.billingId > 0">
                                                <v-card-title>Billing Query</v-card-title>
                                                <v-card-subtitle>Service Dates</v-card-subtitle>
                                                <v-card-text>
                                                   <v-col :key="billingQueryServiceDate.id" v-for="billingQueryServiceDate in billingQueryServiceDates" cols="12">
                                                    <v-switch :label="billingQueryServiceDate.name" v-model="billingQueryServiceDate.isSelected"/>
                                                    <v-textarea placeholder="Describe service date query" v-show="billingQueryServiceDate.isSelected" v-model="billingQueryServiceDate.note"></v-textarea>
                                                   </v-col>
                                                </v-card-text>
                                                <v-card-subtitle>Clinical Notes</v-card-subtitle>
                                                <v-card-text>
                                                   <v-col :key="billingQueryClinicalNote.id" v-for="billingQueryClinicalNote in billingQueryClinicalNotes" cols="12">
                                                    <v-switch :label="billingQueryClinicalNote.name" v-model="billingQueryClinicalNote.isSelected"/>
                                                    <v-textarea placeholder="Describe clinical note query" v-show="billingQueryClinicalNote.isSelected" v-model="billingQueryClinicalNote.note"></v-textarea> 
                                                   </v-col>
                                                </v-card-text>
                                            </v-card>
                                        </v-expand-transition>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-text-field
                                            :disabled="isLoading"
                                            :rules="[
                                               //requiredRule,
                                               lengthRule(50),
                                             ]"
                                            label="Invoice Number"
                                            v-model="account.invoiceNumber"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-text-field
                                            :disabled="isLoading || account.claimId > 0 || account.hasPrefundFunding || account.hasAdminFunding"
                                            :rules="[]"
                                            label="Total Face Value"
                                            min="0"
                                            type="number"
                                            clearable
                                            v-model.number="account.serviceProviderTotalFaceValue"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" v-show="account.id>0">
                                        <v-switch
                                            :disabled="isLoading || (finalAccountStatementRequirement && !account.isFinalAccount)"
                                            class="mb-0"
                                            label="Is Final Account"
                                            v-model="account.isFinalAccount"
                                        ></v-switch>
                                        <div
                                            style="color: grey"
                                            v-show="!account.isFinalAccount && finalAccountStatementRequirement"
                                        >Declaration Statement document is required to set as Final Account.</div>
                                    </v-col>

                                    <v-col cols="12" v-show="!isServiceProviderUser && account.id > 0">
                                        <v-switch
                                            :disabled="isLoading"
                                            class="mb-0"
                                            label="Not Ready For Printing"
                                            v-model="account.notReadyForPrinting">
                                        </v-switch>
                                    </v-col>
                                    
                                    <v-col cols="12" v-show="account.id > 0">
                                        <v-card>
                                            <v-card-text>
                                                <v-switch
                                                    :disabled="isLoading || !(account.patientId > 0) || this.forceAdminFundingType || !isAdminUser || account.claimId > 0"
                                                    class="mb-0 font-weight-bold"
                                                    label="Funding: Prefund"
                                                    v-model="account.hasPrefundFunding"
                                                ></v-switch>
                                                <v-expand-transition>
                                                    <v-row
                                                        no-gutters
                                                        v-show="account.hasPrefundFunding"
                                                    >
                                                        <v-col cols="12">
                                                            <v-text-field
                                                                :disabled="isLoading || account.claimId > 0 || !isAdminUser"
                                                                :rules="[]"
                                                                label="Face Value"
                                                                min="0"
                                                                type="number"
                                                                v-model.number="account.faceValuePrefund"
                                                            ></v-text-field>
                                                        </v-col>
                                                        <v-col cols="12">
                                                            Purchase value: {{prefundPurchaseValue.toFixed(2)}}
                                                        </v-col>
                                                        <v-col cols="12">
                                                            <v-text-field
                                                                :disabled="isLoading || !isAdminUser"
                                                                :rules="[
                                                                          //requiredRule,
                                                                          lengthRule(50),
                                                                        ]"
                                                                label="GRV Number"
                                                                v-model="account.grvNumberPrefund"
                                                            ></v-text-field>
                                                        </v-col>
                                                        <v-col cols="12">
                                                            <v-switch
                                                                :disabled="isLoading || !isAdminUser"
                                                                class="mb-0"
                                                                label="Is Provider Paid"
                                                                v-model="account.isPaidPrefund"
                                                            ></v-switch>
                                                            <v-expand-transition>
                                                                <v-row
                                                                    no-gutters
                                                                    v-show="account.isPaidPrefund"
                                                                >
                                                                    <v-col cols="12">
                                                                        <v-text-field
                                                                            :disabled="isLoading || !isAdminUser"
                                                                            :rules="[]"
                                                                            label="Payment Amount"
                                                                            min="0"
                                                                            type="number"
                                                                            clearable
                                                                            v-model.number="account.paidAmountPrefund"
                                                                        ></v-text-field>
                                                                    </v-col>
        
                                                                    <v-col cols="12">
                                                                        <v-menu
                                                                            :close-on-content-click="false"
                                                                            :nudge-right="40"
                                                                            min-width="290px"
                                                                            offset-y
                                                                            transition="scale-transition"
                                                                            v-model="showPaymentDatePickerPrefund"
                                                                        >
                                                                            <template v-slot:activator="{ on, attrs }">
                                                                                <v-text-field
                                                                                    :disabled="isLoading || !isAdminUser"
                                                                                    clearable
                                                                                    label="Payment Date"
                                                                                    prepend-icon="mdi-calendar-month"
                                                                                    readonly
                                                                                    v-bind="attrs"
                                                                                    v-model="account.paidDatePrefund"
                                                                                    v-on="on"
                                                                                ></v-text-field>
                                                                            </template>
                                                                            <v-date-picker
                                                                                :disabled="isLoading || !isAdminUser"
                                                                                @input="showPaymentDatePickerPrefund = false"
                                                                                v-model="account.paidDatePrefund"
                                                                            ></v-date-picker>
                                                                        </v-menu>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-expand-transition>
                                                        </v-col>
                                                    </v-row>
                                                </v-expand-transition>
                                            </v-card-text>
                                        </v-card>
                                    </v-col>

                                    <v-col cols="12" v-show="account.id > 0">
                                        <v-card>
                                            <v-card-text>
                                                <v-switch
                                                    :disabled="isLoading || !(account.patientId > 0) || this.forceAdminFundingType || !isAdminUser || account.claimId > 0"
                                                    class="mb-0 font-weight-bold"
                                                    label="Funding: Administered"
                                                    v-model="account.hasAdminFunding"
                                                ></v-switch>
                                                <v-expand-transition>
                                                    <v-row
                                                        no-gutters
                                                        v-show="account.hasAdminFunding"
                                                    >
                                                        <v-col cols="12">
                                                            <v-text-field
                                                                :disabled="isLoading || account.claimId > 0 || !isAdminUser"
                                                                :rules="[]"
                                                                label="Face Value"
                                                                min="0"
                                                                type="number"
                                                                v-model.number="account.faceValueAdmin"
                                                            ></v-text-field>
                                                        </v-col>
                                                        <v-col cols="12">
                                                            Purchase value: {{adminPurchaseValue.toFixed(2)}}
                                                        </v-col>
                                                        <v-col cols="12">
                                                            <v-text-field
                                                                :disabled="isLoading || !isAdminUser"
                                                                :rules="[
                                                                          //requiredRule,
                                                                          lengthRule(50),
                                                                        ]"
                                                                label="GRV Number"
                                                                v-model="account.grvNumberAdmin"
                                                            ></v-text-field>
                                                        </v-col>
                                                        <v-col cols="12">
                                                            <v-switch
                                                                :disabled="isLoading || !isAdminUser"
                                                                class="mb-0"
                                                                label="Is Provider Paid"
                                                                v-model="account.isPaidAdmin"
                                                            ></v-switch>
                                                            <v-expand-transition>
                                                                <v-row
                                                                    no-gutters
                                                                    v-show="account.isPaidAdmin"
                                                                >
                                                                    <v-col cols="12">
                                                                        <v-text-field
                                                                            :disabled="isLoading || !isAdminUser"
                                                                            :rules="[]"
                                                                            label="Payment Amount"
                                                                            min="0"
                                                                            type="number"
                                                                            clearable
                                                                            v-model.number="account.paidAmountAdmin"
                                                                        ></v-text-field>
                                                                    </v-col>

                                                                    <v-col cols="12">
                                                                        <v-menu
                                                                            :close-on-content-click="false"
                                                                            :nudge-right="40"
                                                                            min-width="290px"
                                                                            offset-y
                                                                            transition="scale-transition"
                                                                            v-model="showPaymentDatePickerAdmin"
                                                                        >
                                                                            <template v-slot:activator="{ on, attrs }">
                                                                                <v-text-field
                                                                                    :disabled="isLoading || !isAdminUser"
                                                                                    clearable
                                                                                    label="Payment Date"
                                                                                    prepend-icon="mdi-calendar-month"
                                                                                    readonly
                                                                                    v-bind="attrs"
                                                                                    v-model="account.paidDateAdmin"
                                                                                    v-on="on"
                                                                                ></v-text-field>
                                                                            </template>
                                                                            <v-date-picker
                                                                                :disabled="isLoading || !isAdminUser"
                                                                                @input="showPaymentDatePickerAdmin = false"
                                                                                v-model="account.paidDateAdmin"
                                                                            ></v-date-picker>
                                                                        </v-menu>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-expand-transition>
                                                        </v-col>
                                                    </v-row>
                                                </v-expand-transition>
                                            </v-card-text>
                                        </v-card>
                                    </v-col>
                                </v-row>
                                <v-row
                                    align="end"
                                    class="pt-0"
                                    justify="space-between"
                                    no-gutters
                                >
                                    <v-btn
                                        :disabled="isLoading && !isDeleting"
                                        :loading="isDeleting"
                                        @click="deleteEntity"
                                        class="text-none"
                                        color="warning darken-1"
                                        text
                                        v-show="account.id > 0"
                                    >Delete</v-btn>
                                    <v-btn
                                        :disabled="isLoading /*|| (account.accountStatus != allAccountStatuses.Rejected && account.accountStatus != allAccountStatuses.Queried)*/"
                                        @click="resetStatus"
                                        class="text-none"
                                        color="secondary darken-1"
                                        text
                                    >Reset Status</v-btn>
                                    <v-btn
                                        :disabled="isLoading"
                                        @click="closeForm"
                                        class="text-none"
                                        color="secondary darken-1"
                                        text
                                    >Close</v-btn>
                                    <v-btn
                                        :disabled="isLoading && !isSaving"
                                        :loading="isSaving"
                                        @click="saveEntity"
                                        class="text-none"
                                        color="secondary darken-1"
                                        text
                                    >{{ account.id > 0 ? "Update" : "Add" }}</v-btn>
                                </v-row>
                            </v-container>
                        </v-card-text>
                    </v-form>
                    <v-snackbar
                        :color="notifyColor"
                        :timeout="15000"
                        top
                        v-model="notifyShow"
                    >
                        {{ notifyMessage }}
                        <template v-slot:action="{ attrs }">
                            <v-btn
                                @click="notifyShow = false"
                                class="text-none"
                                icon
                                v-bind="attrs"
                            >
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </template>
                    </v-snackbar>
                </v-card>
            </v-col>
            <v-col
                cols="12"
                md="6"
                no-gutters
            >
                <v-col
                    cols="12"
                    v-show="account.id > 0"
                >
                    <h3>
                        Files
                        <v-btn
                            :disabled="isLoading"
                            @click="newAccountFile"
                            class="text-none ml-2"
                            color="secondary darken-1"
                            fab
                            x-small
                        >
                            <v-icon>mdi-plus</v-icon>
                        </v-btn>
                    </h3>

                    <v-card
                        :key="accountFile.id"
                        @click="loadAccountFileForm(accountFile)"
                        class="mt-5"
                        no-gutters
                        v-for="accountFile in account.accountFiles"
                    >
                        <v-card-text class="py-0">
                            <v-row>
                                <v-col cols="8">
                                    {{
                                    accountFileTypes.find(
                                    (x) => x.key == accountFile.accountFileType
                                    )
                                    ? accountFileTypes.find(
                                    (x) => x.key == accountFile.accountFileType
                                    ).value
                                    : ""
                                    }}
                                    <br />
                                    Valid Until:
                                    {{ validUntilDisplay(accountFile.validUntil) }}
                                    <br />
                                    Verified:
                                    {{ accountFile.isVerified ? "Yes" : "No" }}
                                    <br />
                                    Verification Updated By:
                                    {{ accountFile.verfiedByUser }}
                                </v-col>

                                <v-col
                                    align-self="center"
                                    class="text-center"
                                    cols="4"
                                >
                                    <v-btn
                                        @click.stop="
                      $store.dispatch('files/get', {
                        fileId: accountFile.fileId,
                        namePrefix:
                          accountFile.accountId.toString() +
                          '_' +
                          accountFileTypes
                            .find((x) => x.key == accountFile.accountFileType)
                            .value.split(' ')
                            .join('_'),
                      })
                    "
                                        fab
                                    >
                                        <h3>
                                            <v-icon color="light-blue">mdi-download</v-icon>
                                        </h3>
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col
                    cols="12"
                    v-show="account.id > 0"
                >
                    <h3>
                        Notes
                        <v-btn
                            :disabled="isLoading"
                            @click="newNoteShow = true"
                            class="text-none ml-2"
                            color="secondary darken-1"
                            fab
                            x-small
                        >
                            <v-icon>mdi-plus</v-icon>
                        </v-btn>
                    </h3>
                    <v-card
                        :key="note.id"
                        class="mt-5"
                        no-gutters
                        v-for="note in account.notes"
                    >
                        <v-card-subtitle>
                            {{ note.author }}
                            <br />
                            {{ note.createdAt }}
                        </v-card-subtitle>
                        <v-card-text style="white-space: pre-wrap;">{{ note.text }}</v-card-text>
                    </v-card>
                </v-col>

                <v-col
                    cols="12"
                    v-show="account.id > 0"
                >
                    <h3>
                        Clinical Notes
                        <v-btn
                            :disabled="isLoading"
                            @click="newClinicalNoteShow = true"
                            class="text-none ml-2"
                            color="secondary darken-1"
                            fab
                            x-small
                        >
                            <v-icon>mdi-plus</v-icon>
                        </v-btn>
                    </h3>
                    <v-card
                        :key="clinicalNote.id"
                        class="mt-5"
                        no-gutters
                        v-for="clinicalNote in account.clinicalNotes"
                    >
                        <v-card-subtitle>
                            {{ clinicalNote.author }}
                            <br />
                            {{ clinicalNote.createdAt }}
                        </v-card-subtitle>
                        <v-card-text>{{ clinicalNote.text }}</v-card-text>
                        <v-card-text class="pt-0">
                            <strong>Treatment Date:</strong>
                            {{ clinicalNote.treatmentDate.substring(0, 10) }}
                        </v-card-text>
                    </v-card>
                </v-col>

                <v-col
                    cols="12"
                    v-show="account.id > 0"
                >
                    <h3>
                        Billing Queries
                    </h3>
                    <v-card
                        :key="billingQuery.id"
                        class="mt-5"
                        no-gutters
                        v-for="billingQuery in account.billingQueries"
                    >
                        <v-card-text>{{ billingQuery.note }}</v-card-text>
                        <v-card-subtitle>
                           <!-- {{ billingQuery.billingQueryType == 0 ? "Service date query" : "Clinical note query" }}
                            <br />-->
                            {{ billingQuery.createdAt.substring(0,10) }}
                            <br/>
                            <span v-if="billingQuery.resubmitted">Has been resubmitted</span>
                            <v-btn v-else 
                                text
                                @click="$router.push({name: 'Billings',params: {billingId: billingQuery.billingId}})"
                                >
                                Resubmit
                            </v-btn>
                        </v-card-subtitle>
                    </v-card>
                </v-col>
            </v-col>

            <v-dialog
                persistent
                v-model="accountFileFormVisible"
                width="500px"
            >
                <AccountFileForm
                    :account-file-in="accountFileFormEntity"
                    :key="accountFileFormKey"
                    @close="closeAccountFileForm"
                    @deleted="deletedAccountFile"
                    @saved="savedAccountFile"
                />
            </v-dialog>
            <v-dialog
                persistent
                v-model="patientFindFormVisible"
                width="500px"
            >
                <PatientFindForm
                    :key="patientFindFormKey"
                    @close="closePatientFindForm"
                    @located="locatedPatient"
                />
            </v-dialog>
            <v-dialog
                persistent
                v-model="newNoteShow"
                width="500px"
            >
                <v-card>
                    <v-card-title></v-card-title>
                    <v-card-text>
                        <v-textarea
                            :rules="[lengthRule(512)]"
                            counter
                            label="Note"
                            v-model="newNoteText"
                        ></v-textarea>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn
                            @click="
                () => {
                  newNoteShow = false;
                  newNoteText = '';
                }
              "
                            class="text-none"
                            color="secondary darken-1"
                            text
                        >Close</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                            :disabled="isLoading || newNoteAdding || newNoteText.length == 0"
                            :loading="newNoteAdding"
                            @click="newNoteAdd"
                            class="text-none"
                            color="secondary darken-1"
                            text
                        >Add</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog
                persistent
                v-model="newClinicalNoteShow"
                width="500px"
            >
                <v-card>
                    <v-card-title></v-card-title>
                    <v-card-text>
                        <v-textarea
                            :rules="[lengthRule(512)]"
                            counter
                            label="Clinical Note"
                            v-model="newClinicalNoteText"
                        ></v-textarea>
                        <v-col cols="12">
                            <v-menu
                                :close-on-content-click="false"
                                :disabled="isLoading"
                                :nudge-right="40"
                                min-width="290px"
                                offset-y
                                transition="scale-transition"
                                v-model="newClinicalNoteDateMenu"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        :rules="[
                      /*(v) => !!v || 'required'*/
                    ]"
                                        label="Treatment Date"
                                        prepend-icon="mdi-calendar-month"
                                        readonly
                                        v-bind="attrs"
                                        v-model="newClinicalNoteDate"
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    @input="newClinicalNoteDateMenu = false"
                                    v-model="newClinicalNoteDate"
                                ></v-date-picker>
                            </v-menu>
                        </v-col>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn
                            @click="
                () => {
                  newClinicalNoteShow = false;
                  newClinicalNoteText = '';
                  newClinicalNoteDate = null;
                }
              "
                            class="text-none"
                            color="secondary darken-1"
                            text
                        >Close</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                            :disabled="
                isLoading ||
                newClinicalNoteAdding ||
                newClinicalNoteText.length == 0 ||
                !newClinicalNoteDate
              "
                            :loading="newClinicalNoteAdding"
                            @click="newClinicalNoteAdd"
                            class="text-none"
                            color="secondary darken-1"
                            text
                        >Add</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    </v-container>
</template>

<script>
import Account from "../../models/Account.model";
import AccountFile from "../../models/AccountFile.model";
import AccountFileForm from "../forms/AccountFileForm";
import dateToString from "../../helpers/dateToString";
import PatientFindForm from "../forms/PatientFindForm";
import RoleType from "../../constants/RoleType.constant";
import AllAccountStatuses from "../../constants/AccountStatus.constant";
import AccountFileType from "../../constants/AccountFileType.constant";
import uuid4 from "../../helpers/uuid4";
import Billing from "../../models/Billing.model";
export default {
    props: {
        accountIn: Account,
        disciplines: Array
    },
    created: async function() {
        this.userRoles = await this.$store.dispatch(
            "authentication/getUserRoles"
        );

        this.accountFileTypes = await this.$store.dispatch(
            "accounts/getFileTypes"
        );
        this.providers = await this.$store.dispatch("providers/getlist");

        this.accountStatuses = await this.$store.dispatch(
            "accounts/getUserAllowedStatuses"
        );
        this.identityTypes = await this.$store.dispatch("identities/getTypes");
        this.setActiveProvider(this.accountIn.providerId);

        if (
            !(this.accountIn.providerId > 0) &&
            this.providers &&
            this.providers.length > 0
        ) {
            this.account.providerId = this.providers[0].key;
        }
        this.populateProviderDisciplines(this.account.providerId);
    },
    mounted: async function () {
        await this.loadBilling();
        this.loadBillingQueryOptions();

    },
    components: {
        AccountFileForm,
        PatientFindForm
        //
    },
    data() {
        return {
            accountFileType: AccountFileType,
            allAccountStatuses: AllAccountStatuses,
            account: this.loadAccount(this.accountIn),
            userRoles: [],
            billing: new Billing(),
            billingQueryServiceDates: [],
            billingQueryClinicalNotes: [],
            accountFileTypes: [],
            accountStatuses: [],
            identityTypes: [],
            providers: [],
            activeProviders: [],
            patients: [],
            providerDisciplines: [],
            isValid: null,
            isLoading: null,
            isSaving: null,
            isDeleting: null,
            notifyShow: null,
            notifyMessage: null,
            notifyColor: null,
            showPaymentDatePickerPrefund: false,
            showPaymentDatePickerAdmin: false,
            requiredRule: v => !!v || "required",
            requiredQueryRejectReasonRule: v =>
                this.showQueryRejectReasonInput == false ||
                v.trim().length > 0 ||
                "required",
            lengthRule: limit => v =>
                !v || v.length <= limit || "exceeds " + limit + " characters",
            emailRule: v => /.+@.+$/.test(v) || "invalid email",

            accountFileFormKey: null,
            accountFileFormEntity: null,
            accountFileFormVisible: false,

            patientFindFormVisible: false,
            patientFindFormKey: 0,

            newNoteShow: null,
            newNoteAdding: false,
            newNoteText: "",

            newClinicalNoteShow: null,
            newClinicalNoteAdding: false,
            newClinicalNoteText: "",
            newClinicalNoteDate: null,
            newClinicalNoteDateMenu: false,

            fundingTypeOptions: [
                { key: 0, value: "Auto" },
                { key: 1, value: "Prefund" },
                { key: 2, value: "Administered" }
            ],
            forceAdminFundingType: false
        };
    },
    computed: {
        finalAccountStatementRequirement: function() {
            return (
                !this.account.isFinalAccount &&
                (!this.account.accountFiles ||
                    !this.account.accountFiles.some(
                        x =>
                            x.accountFileType ==
                            this.accountFileType.DeclarationStatement
                    ))
            );
        },
        totalFaceValue: function()
        {
            return ((this.account.hasAdminFunding?this.account.faceValueAdmin??0:0)+(this.account.hasPrefundFunding?this.account.faceValuePrefund??0:0)).toFixed(2);
        },
prefundPurchaseValue: function()
{
    return Math.round((this.account.claimId > 0 ? this.account.claimedPurchaseValuePrefund : (this.account.faceValuePrefund / 100) * (100 - this.account.providerPrefundFeePercentage))*100)/100;
},
adminPurchaseValue: function()
{
    return Math.round((this.account.claimId > 0 ? this.account.claimedPurchaseValueAdmin : (this.account.faceValueAdmin / 100) * (100 - this.account.providerAdminFeePercentage))*100)/100;
},
        isServiceProviderUser: function() {
            return (
                this.userRoles.findIndex(
                    x => x == RoleType.ServiceProviderUser
                ) > -1
            );
        },
        isAdminUser: function() {
            return (
                this.userRoles.findIndex(
                    x => x == RoleType.Admin
                ) > -1
            );
        },
        showQueryRejectReasonInput: function() {
            return (
                this.accountIn.accountStatus !== this.account.accountStatus &&
                (this.account.accountStatus ==
                    this.allAccountStatuses.Rejected ||
                    this.account.accountStatus ==
                        this.allAccountStatuses.Queried)
            );
        }
    },
    methods: {
        loadBillingQueryOptions() {
            this.billingQueryServiceDates = this.billing.billingItems.map(x => {
            return {
                billingId: x.billingId,
                billingItemId: x.id,
                isSelected: false,
                note: '',
                name: x.dateOfService.substring(0,10) + " (" + x.invoiceNumber + ")",
                billingQueryType: 0
            };
        });
        this.billingQueryClinicalNotes = this.billing.billingItems.map(x => {
            return {
                billingId: x.billingId,
                billingItemId: x.id,
                isSelected: false,
                note: '',
                name: x.dateOfService.substring(0,10) + " (" + x.invoiceNumber + ")",
                billingQueryType: 1
            };
        });
        },
        async loadBilling()
        {
            if (this.account.billingId > 0) {
                var requestId = (this.requestId = uuid4());
                var billingResponse = await this.$store.dispatch(
                    "billings/get",
                    {
                        id: this.account.billingId,
                        urlParameters: {},
                        requestId: requestId,
                    }
                );
                if (
                    this.requestId == billingResponse.requestId &&
                    billingResponse.data.total == 1 &&
                    billingResponse.data.page[0].id == this.account.billingId
                ) {
                    this.billingIn = billingResponse.data.page[0];
                    this.billing = new Billing().set(this.billingIn);


                }
            } else if (this.billingIdValue === 0) {
                this.billing = new Billing();
            }
        },
        loadAccount(accountToLoad) {
            var toLoad = new Account().set(accountToLoad);

            toLoad.paidDatePrefund = dateToString(
                toLoad.paidDatePrefund ? new Date(toLoad.paidDatePrefund) : null
            );

            toLoad.paidDateAdmin = dateToString(
                toLoad.paidDateAdmin ? new Date(toLoad.paidDateAdmin) : null
            );

            return toLoad;
        },
        setActiveProvider(providerId)
        {
            this.activeProviders = this.providers.filter(x => x.disabled == false || (providerId > 0 && x.key == providerId)).map(x => {const obj = {}; obj.value = x.value; obj.key = x.key; return obj;});
        },
        populateProviderDisciplines(providerId) {
            this.isLoading = true;
            this.$store
                .dispatch(
                    "providers/getDisciplines",
                    this.account.id > 0 ? undefined : providerId
                )
                .then(result => {
                    if (providerId == this.account.providerId && result) {
                        this.providerDisciplines = result;
                        if (
                            this.providerDisciplines.length > 0 &&
                            !(this.account.discipline > 0)
                        )
                            this.account.discipline = this.providerDisciplines[0].key;
                    }
                })
                .finally(() => (this.isLoading = false));
        },

        //note
        newNoteAdd() {
            this.isLoading = true;
            this.newNoteAdding = true;
            this.$store
                .dispatch("accounts/addNote", {
                    accountId: this.account.id,
                    text: this.newNoteText
                })
                .then(
                    response => {
                        this.account.notes.push({
                            id: response.id,
                            author: response.author,
                            text: response.text,
                            createdAt: response.createdAt
                        });
                        this.emitSavedEntity(null);
                        this.newNoteAddingDone();
                        this.newNoteShow = false;
                        this.newNoteText = "";
                    },
                    error => this.notify(error.response.data, "error")
                )
                .finally(this.newNoteAddingDone);
        },
        newNoteAddingDone() {
            this.newNoteAdding = false;
            this.isLoading = false;
        },

        validUntilDisplay(date) {
            var dateOut = dateToString(date ? new Date(date) : null);
            return dateOut ? dateOut : "Indefinitely";
        },

        //clinicalClinicalNote
        newClinicalNoteAdd() {
            this.isLoading = true;
            this.newClinicalNoteAdding = true;
            this.$store
                .dispatch("accounts/addClinicalNote", {
                    accountId: this.account.id,
                    text: this.newClinicalNoteText,
                    treatmentDate: this.newClinicalNoteDate
                })
                .then(
                    response => {
                        this.account.clinicalNotes.push({
                            id: response.id,
                            author: response.author,
                            text: response.text,
                            treatmentDate: response.treatmentDate,
                            createdAt: response.createdAt
                        });
                        this.emitSavedEntity(null);
                        this.newClinicalNoteAddingDone();
                        this.newClinicalNoteShow = false;
                        this.newClinicalNoteText = "";
                        this.newClinicalNoteDate = null;
                    },
                    error => this.notify(error.response.data, "error")
                )
                .finally(this.newClinicalNoteAddingDone);
        },
        newClinicalNoteAddingDone() {
            this.newClinicalNoteAdding = false;
            this.isLoading = false;
        },
        //subform handlers--------------------
        savedAccountFile(accountFileIn) {
            var updateIndex = this.account.accountFiles.findIndex(
                x => x.id == accountFileIn.id
            );
            if (updateIndex > -1)
                this.$set(
                    this.account.accountFiles,
                    updateIndex,
                    accountFileIn
                );
            else this.account.accountFiles.push(accountFileIn);
            this.emitSavedEntity(this.account);
        },
        deletedAccountFile(accountFileIn) {
            var deletedIndex = this.account.accountFiles.findIndex(
                x => x.id == accountFileIn.id
            );
            if (deletedIndex > -1)
                this.$delete(this.account.accountFiles, deletedIndex);

            this.emitDeletedEntity(accountFileIn);
        },
        newAccountFile() {
            var accountFile = new AccountFile();
            accountFile.id = 0;
            accountFile.accountId = this.account.id;
            this.loadAccountFileForm(accountFile);
        },
        loadAccountFileForm(accountFile) {
            this.accountFileFormEntity = accountFile;
            this.accountFileFormKey = accountFile.id;
            this.accountFileFormVisible = true;
        },
        closeAccountFileForm() {
            this.accountFileFormKey = null;
            this.accountFileFormVisible = false;
        },

        //patient find forms-------------------
        loadPatientFindForm() {
            this.patientFindFormKey += 1;
            this.patientFindFormVisible = true;
        },
        closePatientFindForm() {
            this.patientFindFormVisible = false;
        },
        locatedPatient(patient) {
            this.account.patientId = patient.id;
            this.account.patient = patient;
            if(patient.isAdminAccount && !(this.account.id > 0))
            {
                this.forceAdminFundingType = true;
                this.account.hasAdminFunding = true;
                this.account.hasPrefundFunding = false;
            }
        },
        //emitters      ------------------------------------------------------------
        emitSavedEntity(savedAccount) {
            //var newDiscipline = this.disciplines.find(
            //   (x) => x.id == savedAccount.discipline
            //);
            //if (newDiscipline) savedAccount.disciplineName = newDiscipline.name;
            this.$emit("saved", savedAccount);
        },
        emitDeletedEntity(deletedAccount) {
            this.$emit("deleted", deletedAccount);
        },
        emitCloseForm() {
            this.$emit("close");
        },
        //general       ------------------------------------------------------------
        notify(message, color) {
            this.notifyShow = true;
            this.notifyMessage = message;
            this.notifyColor = color;
        },
        closeForm() {
            this.notifyShow = false;
            this.emitCloseForm();
        },
        validateForm() {
            this.isValid = this.$refs.accountForm.validate();
            return this.isValid && this.account.patient;
        },
        //reset status----------------------------------------------------------
        resetStatus() {
            this.$store
                .dispatch("accounts/resetstatus", this.account)
                .then(
                    accountWithInfo => {
                        this.notify(
                            "Account status successfully reset.",
                            "success"
                        );
                        this.emitSavedEntity(accountWithInfo);
                        this.closeForm();
                    },
                    error => this.notify(error.response.data, "error")
                )
                .finally(this.resetStatusDone);
        },
        resetStatusDone() {
            this.isLoading = false;
        },
        //save      ------------------------------------------------------------
        async saveEntity() {
            if (this.validateForm()) {
                this.isLoading = true;
                this.isSaving = true;

                if (!this.account.serviceProviderTotalFaceValue) this.account.serviceProviderTotalFaceValue = 0;
                if (!this.account.faceValueAdmin) this.account.faceValueAdmin = 0;
                if (!this.account.adminFeePercentage) this.account.adminFeePercentage = 0;
                if (!this.account.prefundFeePercentage) this.account.prefundFeePercentage = 0;
                if (!this.account.faceValuePrefund) this.account.faceValuePrefund = 0;
                if (!this.account.faceValueAdmin) this.account.faceValueAdmin = 0;
                if (!this.account.paidAmountPrefund) this.account.paidAmountPrefund = 0;
                if (!this.account.paidAmountAdmin) this.account.paidAmountAdmin = 0;

                let accountDto = {
                    account: this.account,
                    billingQuery: this.billingQueryServiceDates.filter(x => x.isSelected == true).concat(this.billingQueryClinicalNotes.filter(x => x.isSelected == true))
                };
                accountDto.billingQuery.forEach(x => {
                    x.note = (x.billingQueryType == 0 ? "Service date query, " : "Clinical note query, ") + x.name + ": " + x.note;                     
                });

                try {
                    let accountWithInfo = await this.$store
                    .dispatch("accounts/" + (this.account.id == 0 ? "create" : "update"), (this.account.id == 0 ? this.account : accountDto))
                    this.notify(
                        "Account successfully saved.",
                        "success"
                    );
                    if (this.account.id == 0) {
                        this.account.id = accountWithInfo.entity.id;
                    }
                    this.accountIn.accountStatus =
                        accountWithInfo.entity.accountStatus;
                    this.account.accountStatus =
                        accountWithInfo.entity.accountStatus;
                    this.account.queryText = "";
                    this.account = this.loadAccount(accountWithInfo.entity),
                    await this.loadBilling();
                    this.loadBillingQueryOptions();
                    this.emitSavedEntity(accountWithInfo);
                } catch (e) {
                    this.notify(e.response.data, "error");
                } finally {
                    this.saveEntityDone();
                }
            }
        },
        saveEntityold() {
            if (this.validateForm()) {
                this.isLoading = true;
                this.isSaving = true;

                if (!this.account.serviceProviderTotalFaceValue) this.account.serviceProviderTotalFaceValue = 0;
                if (!this.account.faceValueAdmin) this.account.faceValueAdmin = 0;
                if (!this.account.adminFeePercentage) this.account.adminFeePercentage = 0;
                if (!this.account.prefundFeePercentage) this.account.prefundFeePercentage = 0;
                if (!this.account.faceValuePrefund) this.account.faceValuePrefund = 0;
                if (!this.account.faceValueAdmin) this.account.faceValueAdmin = 0;
                if (!this.account.paidAmountPrefund) this.account.paidAmountPrefund = 0;
                if (!this.account.paidAmountAdmin) this.account.paidAmountAdmin = 0;

                let accountDto = {
                    account: this.account,
                    billingQuery: this.billingQueryServiceDates.filter(x => x.isSelected == true).concat(this.billingQueryClinicalNotes.filter(x => x.isSelected == true))
                };
                accountDto.billingQuery.forEach(x => {
                    x.note = (x.billingQueryType == 0 ? "Service date query, " : "Clinical note query, ") + x.name + ": " + x.note;                     
                });
                this.$store
                    .dispatch(
                        "accounts/" +
                            (this.account.id == 0 ? "create" : "update"),
                            accountDto//this.account
                    )
                    .then(
                        accountWithInfo => {
                            this.notify(
                                "Account successfully saved.",
                                "success"
                            );
                            if (this.account.id == 0) {
                                this.account.id = accountWithInfo.entity.id;
                            }
                            this.accountIn.accountStatus =
                                accountWithInfo.entity.accountStatus;
                            this.account.accountStatus =
                                accountWithInfo.entity.accountStatus;
                            this.account.queryText = "";
                            this.emitSavedEntity(accountWithInfo);
                        },
                        error => this.notify(error.response.data, "error")
                    )
                    .finally(this.saveEntityDone);
            }
        },
        saveEntityDone() {
            this.isLoading = false;
            this.isSaving = false;
        },
        //delete        ------------------------------------------------------------
        deleteEntity() {
            var isConfirmed = confirm(
                "Are you sure you want to delete this account profile?"
            );
            if (isConfirmed) {
                this.isLoading = true;
                this.isDeleting = true;
                this.$store
                    .dispatch("accounts/delete", this.account.id)
                    .then(
                        () => {
                            this.notify(
                                "Account successfully deleted.",
                                "success"
                            );
                            this.emitDeletedEntity(this.account);
                            this.closeForm();
                        },
                        error => this.notify(error.response.data, "error")
                    )
                    .finally(this.deleteEntityDone);
            }
        },
        deleteEntityDone() {
            this.isLoading = false;
            this.isDeleting = false;
        }
    }
};
</script>

<style lang="stylus" scoped></style>